<script setup lang="ts">
interface Props {
  type?: 'flex' | 'grid' // TODO: delete 'flex' type, leave only 'grid'
}

withDefaults(defineProps<Props>(), {
  type: 'flex',
})
</script>

<template>
  <div
    class="flex-1"
    :class="{
      'flex-gap-y-fluid': type === 'flex',
      'gap-y-fluid grid': type === 'grid',
    }"
  >
    <slot />
  </div>
</template>
